import { Box, Group, Text } from '@mantine/core';

type LegendDotProps = {
  color: string;
  label: string;
};

const LegendDot: React.FC<LegendDotProps> = ({ color, label }) => (
  <Group gap={4}>
    <Box w={8} h={8} style={{ borderRadius: '50%', backgroundColor: color }} />
    <Text fw={600} fz="xs">
      {label}
    </Text>
  </Group>
);

export default LegendDot;
